import { render, staticRenderFns } from "./StateOverridesSection.vue?vue&type=template&id=10befce8&scoped=true"
import script from "./StateOverridesSection.vue?vue&type=script&lang=js"
export * from "./StateOverridesSection.vue?vue&type=script&lang=js"
import style0 from "./StateOverridesSection.vue?vue&type=style&index=0&id=10befce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10befce8",
  null
  
)

export default component.exports